<template>
  <div class="main-content-container container-fluid px-4">
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <d-card-header
            class="d-flex justify-content-between align-items-center"
          >
            <h2 class="h4">
              {{ !!count ? `${count} Total Documents` : "No Documents" }}
            </h2>
          </d-card-header>
          <d-card-body class="p-0 pb-3 text-center overflow-auto">
            <loading v-if="loading" />
            <table v-else-if="!!count" class="table mb-0">
              <thead class="bg-light">
                <tr>
                  <th scope="col" class="border-0">Filename</th>
                  <th scope="col" class="border-0">Uploaded</th>
                  <th scope="col" class="border-0">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="doc in documents" :key="doc.key">
                  <td>{{ doc.filename }}</td>
                  <td>{{ oneTimeFormat(doc.created) }}</td>
                  <td>
                    <d-button @click="activateSecureUrl(doc.secure_url)" link
                      >Open</d-button
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- <div v-else class="d-flex justify-content-center align-items-center py-3">NO DOCUMENTS</div> -->
          </d-card-body>
          <d-card-footer
            class="justify-content-center align-items-center"
            :class="{ 'd-none': !!!count, 'd-flex': !!count }"
          >
            <Paginator
              :nextClick="nextPage"
              :prevClick="prevPage"
              :numPages="this.$store.state.documents.numPages"
              :pageNum="this.$store.state.documents.pageNum"
            />
          </d-card-footer>
        </d-card>
      </d-col>
    </d-row>
  </div>
</template>

<script>
import Paginator from "@/components/common/Paginator.vue";
import { oneTimeFormat } from "@/helpers";

export default {
  components: {
    Paginator
  },
  created() {
    this.$store.dispatch("documents/initDocuments");
    this.$store.dispatch("app/setTitles", { title: "Documents", subtitle: "" });
  },
  computed: {
    count() {
      return this.$store.state.documents.count;
    },
    documents() {
      return this.$store.state.documents.documents;
    },
    loading() {
      return this.$store.state.documents.loading;
    }
  },
  methods: {
    nextPage() {
      this.$store.dispatch("documents/nextDocuments");
    },
    prevPage() {
      this.$store.dispatch("documents/prevDocuments");
    },
    activateSecureUrl(url) {
      this.$store.dispatch("documents/activateSecureUrl", url);
    },
    oneTimeFormat
  }
};
</script>

<style lang="scss" scoped>
.action-btn {
  font-size: 1rem;
}
</style>
